'use client'

import { env } from '@/env';
import posthog from 'posthog-js';
import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import SuspendedPostHogPageView from './posthogPageView';

export function PostHogProvider({ children }: {
  children: React.ReactNode;
}) {
  const isPosthogEnabled = env.NODE_ENV === 'production';

  // Initialize PostHog when the component mounts
  useEffect(() => {
    if (!isPosthogEnabled) {
      return;
    }
    posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: env.NEXT_PUBLIC_POSTHOG_HOST,
      capture_pageview: false,
    })
  }, [isPosthogEnabled])

  return (
    <PHProvider client={posthog}>
      {isPosthogEnabled ? <SuspendedPostHogPageView /> : null}
      {children}
    </PHProvider>
  )
}
